import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { SessionStorageService } from '../../../../core/services/web-storage';

const sessionStorageKey = 'user_avatar';

@Injectable({
    providedIn: 'root'
})
/** Service para manipular o avatar do usuário */
export class UsuarioAvatarService {
    /** Subject de mudanças na URL de avatar do usuário */
    private subject = new Subject<string>();

    constructor(private sessionStorageService: SessionStorageService) {}

    /** Retorna o subject de mudanças na URL do avatar do usuário */
    getSubject(): Subject<string> {
        return this.subject;
    }

    /** Notifica os observers de mudanças na URL do avatar do usuário */
    next(avatarUrl: string) {
        this.sessionStorageService.set(sessionStorageKey, avatarUrl);
        this.subject?.next(avatarUrl);
    }

    /** Retorna a URL da imagem do avatar do usuário */
    getUrl(): string {
        return this.sessionStorageService.get(sessionStorageKey);
    }
}
